import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export class MxController extends Controller {
  queryParams = ['studentGrade', 'lessonLevelDomainIds']

  @tracked studentGrade = 'all'

  @tracked lessonLevelDomainIds = []
}

export default MxController

declare module '@ember/controller' {
  interface Registry {
    'reporting/ui-scope/mx': MxController
  }
}
